<template>
    <div :class="content.classes + ' content'">
        <div
                @mouseenter="show_options = true"
                @mouseleave="close_toolbar"
             :class="'content_wrapper'+content.type">
            <blocks-functions-video
            :is_visible="show_options"
            :item="content"
            :close_function="close_toolbar"
            >

            </blocks-functions-video>

            <iframe width="100%"
                    height="100%"
                    style="min-height:250px;"
                    :src="content.value.replace('watch?v=', 'embed/')"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            content: Object
        },
        components: {},
        data() {
            return {
                show_options: false,

            }
        },
        methods: {
            close_toolbar() {
                this.show_options = false;
            }
        }
    }
</script>
